const config = {
  apiUrl: 'https://aws-api.locumspace.co/api/v1/',
  healthDashboardUrl: 'https://locum-health.web.app',
  websiteUrl: 'https://locumspace.co',
};

export default config;
